import React from 'react';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import { Box, Tooltip } from '@ublend-npm/aulaui-core';
import {
  SPACE_CARD_ICON_BUTTON_PADDING,
  SPACE_CARD_ICON_BUTTON_RADIUS,
  SPACE_CARD_ICON_BUTTON_SIZE,
  SPACE_CARD_ICON_COMMUNITY_LABEL,
  SPACE_CARD_ICON_GLYPH_COLOR,
  SPACE_CARD_ICON_GLYPH_SIZE,
  SPACE_CARD_ICON_LEARNING_LABEL,
  SPACE_CARD_ICON_THUMBNAIL_BG,
} from './spaceWidgetConstants';

type SpaceCardBookIconProps = {
  backgroundColor?: string;
  glyphColor?: string;
  isCommunity?: boolean;
};

/** Figma medium space icon — book for courses, Groups2Outlined for communities. */
const SpaceCardBookIcon = ({
  backgroundColor = SPACE_CARD_ICON_THUMBNAIL_BG,
  glyphColor = SPACE_CARD_ICON_GLYPH_COLOR,
  isCommunity = false,
}: SpaceCardBookIconProps) => {
  const label = isCommunity
    ? SPACE_CARD_ICON_COMMUNITY_LABEL
    : SPACE_CARD_ICON_LEARNING_LABEL;

  return (
    <Tooltip title={label} placement="top" arrow>
      <Box
        aria-label={label}
        className="space-card-icon"
        role="img"
        tabIndex={0}
        sx={{
          position: 'relative',
          width: SPACE_CARD_ICON_BUTTON_SIZE,
          height: SPACE_CARD_ICON_BUTTON_SIZE,
          borderRadius: SPACE_CARD_ICON_BUTTON_RADIUS,
          bgcolor: backgroundColor,
          p: SPACE_CARD_ICON_BUTTON_PADDING,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          boxSizing: 'border-box',
          color: glyphColor,
          outline: 'none',
        }}
      >
        {isCommunity ? (
          <Groups2OutlinedIcon
            aria-hidden
            sx={{
              width: SPACE_CARD_ICON_GLYPH_SIZE,
              height: SPACE_CARD_ICON_GLYPH_SIZE,
              fontSize: SPACE_CARD_ICON_GLYPH_SIZE,
            }}
          />
        ) : (
          <AutoStoriesOutlinedIcon
            aria-hidden
            sx={{
              width: SPACE_CARD_ICON_GLYPH_SIZE,
              height: SPACE_CARD_ICON_GLYPH_SIZE,
              fontSize: SPACE_CARD_ICON_GLYPH_SIZE,
            }}
          />
        )}
      </Box>
    </Tooltip>
  );
};

export default SpaceCardBookIcon;
